window.addEventListener('SITE_START', () => {
  const currentPage = document.querySelector('#history.wrapper');
  if (!currentPage) return;

  const $stickyContainer = document.querySelector('.sticky-container');
  const $stickyNav = $stickyContainer.querySelector('.sticky-nav');
  const $navList = $stickyNav.querySelectorAll('.__item');

  requestAnimationFrame(() => {
    if ($stickyContainer) stickyNavController();
  });

  let leftArticleHeight = 0;

  visualIntroAnim();
  historyProgress(); // pc
  setLeftArticlePaddingBottom(); // mo
  mobileProgressBarAnim(); // mo
  historyNavActive();

  // sticky nav 공통 관리 필요
  function stickyNavController() {
    ScrollTrigger.create({
      trigger: $stickyContainer,
      start: 'top-=10 top',
      end: 'bottom bottom',
      onEnter: () => {
        $stickyNav.classList.add('--visible');
      },
      onLeaveBack: () => {
        $stickyNav.classList.remove('--visible');
      },
    });

    $navList.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        $navList.forEach(($el) => $el.classList.remove('--active'));
        item.classList.add('--active');

        const id = item.querySelector('a').getAttribute('href');
        const scrollSection = document.querySelector(`[data-id="${id.replace('#', '')}"]`);

        if (scrollSection) {
          gsap.to(window, { duration: 0, scrollTo: scrollSection });
        }
        history.pushState(null, '', id);
      });
    });
  }

  function visualIntroAnim() {
    const section = document.querySelector('.visual-intro');
    if (!section) return;

    const text = section.querySelector('.text');
    const maskReveal = section.querySelector('.visual-mask__reveal');

    if (!maskReveal) return;

    const vw = section.clientWidth;
    const vh = section.clientHeight;
    const min = Math.min(vw, vh);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 20%',
        end: 'bottom bottom',
        // markers: true,
        // toggleActions: 'play none none reverse',
        toggleActions: 'play none none none',
      },
    });

    tl.fromTo(
      maskReveal,
      {
        width: min * 0.25,
        height: min * 0.25,
        borderRadius: `${(min * 0.25) / 2}px`,
      },
      {
        width: min * 0.5,
        height: min * 0.5,
        borderRadius: `${(min * 0.5) / 2}px`,
        duration: 0.3,
        ease: 'linear',
      }
    )
      .to(maskReveal, {
        width: vw * 1.1,
        height: vh * 1.1,
        borderRadius: '0px',
        duration: 0.4,
        ease: 'linear',
      })
      .fromTo(
        text,
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          ease: 'power2.out',
        },
        '-=0.2'
      );

    if (window.innerWidth > 768) {
      ScrollTrigger.create({
        trigger: section,
        start: 'top bottom',
        onLeaveBack: () => {
          tl.progress(0).pause();
        },
      });
    }
  }

  function historyProgress() {
    const section = document.querySelector('.history-list');
    const barWrap = section.querySelector('.__progress-bar.--fixed');
    const bar = barWrap.querySelector('span');
    const items = section.querySelectorAll('.history-list__item');
    const lastItem = items[items.length - 1];

    if (!barWrap || !bar || !items.length) return;

    const firstContent = items[0].querySelector('.__content');
    const contentmarginTop = parseFloat(getComputedStyle(firstContent).marginTop) || 0;

    const vh = window.innerHeight;
    const halfHeight = vh * 0.5;
    const fullHeight = vh;

    ScrollTrigger.create({
      trigger: section,
      start: `top+=${contentmarginTop} top`,
      endTrigger: lastItem,
      end: 'bottom bottom',
      onEnter: () => barWrap.classList.add('is-sticky'),
      onLeave: () => barWrap.classList.remove('is-sticky'),
      onEnterBack: () => barWrap.classList.add('is-sticky'),
      onLeaveBack: () => barWrap.classList.remove('is-sticky'),
    });

    ScrollTrigger.create({
      trigger: items[0],
      start: 'top bottom',
      endTrigger: items[1],
      end: 'bottom top',
      scrub: true,
      // markers: true,
      onUpdate: (self) => {
        const p = self.progress;
        const h = halfHeight * p; // 0 → 50%
        gsap.set(bar, { height: h });
      },
    });

    ScrollTrigger.create({
      trigger: lastItem,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: (self) => {
        const p = self.progress;
        const h = halfHeight + (fullHeight - halfHeight) * p; // 50% → 100%
        gsap.set(bar, { height: h });
      },
      onLeave: () => gsap.set(bar, { height: '100%' }),
    });

    items.forEach((item, idx) => {
      // 이 아이템 안의 이미지들 (겹쳐진 구조)
      const motionImgs = item.querySelectorAll('.__img .img:not(.--default)');
      const imgCount = motionImgs.length; // 기본 이미지는 제외하고 계산
      if (!imgCount) return;

      ScrollTrigger.create({
        trigger: item,
        start: 'top 65%',
        end: 'bottom 35%',
        scrub: true,
        // markers: true,
        onUpdate: (self) => {
          const p = self.progress; // 0 ~ 1

          // 범위 20% ~ 80% 내에서 이미지 전환
          const min = 0.2;
          const max = 0.8;

          let rangeProgress = (p - min) / (max - min);
          rangeProgress = Math.min(Math.max(rangeProgress, 0), 1);

          const step = 1 / imgCount;
          const offset = step * 0.3;

          motionImgs.forEach((img, i) => {
            const threshold = step * (i + 1) - offset;
            if (rangeProgress >= threshold) {
              img.classList.add('show');
            } else {
              img.classList.remove('show');
            }
          });
        },
      });
    });

    // 연혁 컨텐츠들 인모션
    ScrollTrigger.create({
      trigger: items[0],
      start: 'top 80%',
      end: 'bottom top',
      // markers: true,
      onEnter: () => section.classList.add('--active'),
      // onLeave: () => section.classList.remove('--active'),
      // onEnterBack: () => section.classList.add('--active'),
      // onLeaveBack: () => section.classList.remove('--active')
    });
  }

  function setLeftArticlePaddingBottom() {
    if (window.innerWidth > 1024) return;

    const historyList = document.querySelector('.history-list');
    const items = document.querySelectorAll('.history-list .history-list__item');

    items.forEach((item) => {
      const windowHeight = window.innerHeight;
      const leftArticle = item.querySelector('.__left-article');

      const style = window.getComputedStyle(leftArticle);
      const paddingBottom = parseFloat(style.paddingBottom);
      const pureHeight = leftArticle.clientHeight - paddingBottom;
      const height = windowHeight - pureHeight;

      leftArticleHeight = height;
      historyList.style.setProperty('--height', `${height}px`);
    });
  }

  function mobileProgressBarAnim() {
    if (window.innerWidth > 1024) return;

    const items = document.querySelectorAll('.history-list .history-list__item');

    items.forEach((item) => {
      const content = item.querySelector('.__content');
      const progressBar = item.querySelector('.__progress-bar.--left span');

      if (!content || !progressBar) return;

      gsap.fromTo(
        progressBar,
        { height: '0%' },
        {
          height: '100%',
          ease: 'none',
          scrollTrigger: {
            trigger: content,
            start: `top ${leftArticleHeight + 40}`,
            end: 'bottom bottom',
            scrub: true,
            // markers: true
          },
        }
      );
    });
  }

  function historyNavActive() {
    const nav = document.querySelector('.sticky-nav');
    const inner = nav.querySelector('.__inner');
    const navItems = nav.querySelectorAll('.__item');
    const sections = document.querySelectorAll('.history-list__item');

    sections.forEach((section) => {
      const id = section.dataset.id;
      const targetNav = nav.querySelector(`.__item a[href="#${id}"]`)?.closest('.__item');
      if (!targetNav) return;

      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => setActive(targetNav),
        onEnterBack: () => setActive(targetNav),
      });
    });

    function setActive(target) {
      navItems.forEach((item) => item.classList.remove('--active'));
      target.classList.add('--active');

      if (window.innerWidth <= 768) {
        const innerRect = inner.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const offset = targetRect.left - innerRect.left + inner.scrollLeft - 20;

        inner.scrollTo({
          left: offset,
          behavior: 'smooth',
        });
      }
    }
  }

  detectRealResize(() => {
    setLeftArticlePaddingBottom();
    historyProgress();
    visualIntroAnim();
    mobileProgressBarAnim();
    historyNavActive();
    stickyNavController();
    ScrollTrigger.refresh();
  });
});
